import React from 'react';
// import PropTypes from 'prop-types';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import ProfileFormCard from '../components/ProfileFormCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class ProfileScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.PROFILE,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_PERFIL_DE_USUARIO')} breadcrumbs={breadcrumbs}>
                <ProfileFormCard/>
            </PsPage>
        );
    }
}

ProfileScreen.propTypes = {};

ProfileScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/profile/screens/ProfileScreen.js